var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeurology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000044884349054171956280000005399738937176233092_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000146466158718874228950000018226523800844746943_);}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183229897809861647170000002000408361002061224_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183229897809861647170000002000408361002061224_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181792459451692222920000002576660762073995183_",
    x: 6.9,
    y: 6.1,
    width: 89.1,
    height: 89.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008142865903584246060000017431071276045633158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181792459451692222920000002576660762073995183_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000008142865903584246060000017431071276045633158_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.3,81.1c-6.2,0-11.5-5-11.5-11.1c0-2.7,1-5.1,2.6-7c-5.6-0.7-9.9-5.3-9.9-11c0-5.9,4.8-10.8,10.7-11.1 c-1.6-1.9-2.5-4.3-2.5-6.9c0-6.1,5.1-11.1,11.3-11.1c-0.1-0.5-0.1-1-0.1-1.4c0-6.1,5-11.1,11.3-11.1c6.2,0,11.3,5,11.3,11.1h0 v58.1c0,6.3-5.2,11.5-11.6,11.5C33.9,91,29.1,86.7,28.3,81.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.4,42c4.9,0,8.8,3.9,8.8,8.6c0,4.8-3.9,8.6-8.8,8.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29,22.9c0.7,5.2,5.2,9.2,10.7,9.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.3,81.1c-0.1-0.5-0.1-1.1-0.1-1.6c0-6.3,5.2-11.5,11.6-11.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.4,79.5c0,6.3,5.2,11.5,11.6,11.5c5.9,0,10.7-4.3,11.5-9.8c6.2,0,11.5-5,11.5-11.1c0-2.7-1-5.1-2.6-7 c5.6-0.7,9.9-5.3,9.9-11c0-5.9-4.8-10.8-10.7-11.1c1.6-1.9,2.5-4.3,2.5-6.9c0-6.1-5.1-11.1-11.3-11.1c0.1-0.5,0.1-1,0.1-1.4 c0-6.1-5-11.1-11.3-11.1c-6.2,0-11.3,5-11.3,11.1h0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.5,42c-4.8,0-8.8,3.9-8.8,8.6c0,4.8,3.9,8.6,8.8,8.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M73.8,22.9c-0.7,5.2-5.2,9.2-10.7,9.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.6,81.1c0.1-0.5,0.1-1.1,0.1-1.6c0-6.3-5.2-11.5-11.6-11.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurology);
export default __webpack_public_path__ + "static/media/Neurology.bd80db25ee2d3a0e878a81742466bb63.svg";
export { ForwardRef as ReactComponent };